import React, { useState } from "react"
import AcButton from "../atoms/AcButton"
import AcIcon from "../atoms/AcIcon"
import AcModal from "../atoms/AcModal"
import styled from "styled-components"
import ContractUploader from "../molecules/ContractUploader"
import { useRequest } from "~/api/Request"
import { ValidateCSVRes } from "~/model/ImportCSV"
import { useRouter } from "next/router"
import { useGlobal } from "~/composable/useGlobal"
import { useImport } from "~/composable/useImport"

function ModalImportCSV() {
  const { importCheckContractCsv, importContract } = useImport()
  const [showImportCSV, setShowImportCSV] = useState(false)

  const { Request } = useRequest()
  const router = useRouter()
  const [importStatus, setImportStatus] = useState<"upload" | "validate" | "done">("upload")

  const [file, setFile] = useState<globalThis.File>(null)

  const [dataValidate, setDataValidate] = useState<ValidateCSVRes>({
    overload: 0,
    totalRows: 0,
    totalRowIncorrect: 0,
    totalDuplicate: 0,
    totalUpdate: 0,
    availability: [],
    error: [],
    dataNew: [],
    dataUpdate: [],
  })

  const onSuccess = (fileList: FileList) => {
    const fileImport = fileList[0]
    setFile(fileImport)
  }
  const { showDialog } = useGlobal()

  const onDelete = () => {
    setFile(null)
  }

  const onHideModal = () => {
    setShowImportCSV(false)
    onDelete()
    setImportStatus("upload")
  }

  const onValidateFile = async () => {
    const formData = new FormData()

    formData.append("file", file)

    try {
      const res = await importCheckContractCsv(formData)
      if (res.data.overload > 0) {
        setFile(null)
        setShowImportCSV(false)
        showDialog(
          "アップロードエラー",
          <OnverloadText>
            <p className="over-note">下書き保存できる上限は500件です。</p>
            <p>CSVファイルを分割するなど、</p>
            <p>案件数を合計500件以下に調整してから再度アップロードしてください。</p>
          </OnverloadText>,
          "閉じる"
        )
      } else {
        setDataValidate(res.data)
        setImportStatus("validate")
      }
    } catch (error) {
      showDialog(
        "アップロードエラー",
        <ImportFileError>
          {error.message.map((item, i) => (
            <div key={i}>{item}</div>
          ))}
        </ImportFileError>,
        "閉じる"
      )
    }
  }

  const onImportCSV = async () => {
    try {
      await importContract(dataValidate.dataNew, dataValidate.dataUpdate)
      setImportStatus("done")
    } catch (error) {
      showDialog(
        "アップロードエラー",
        <ImportFileError>
          {error.message.map((item, i) => (
            <div key={i}>{item}</div>
          ))}
        </ImportFileError>,
        "閉じる"
      )
    }
  }

  const toDraftList = () => {
    router.push("/contracts/draft")
  }

  return (
    <>
      <AcButton className={"resister-btn"} onClick={() => setShowImportCSV(true)}>
        <AcIcon name="plus" />
        新規登録
      </AcButton>
      <AcModal show={showImportCSV} title="新規登録" onHide={onHideModal} size="lg">
        <ModalContent key={"body"}>
          {importStatus === "upload" && (
            <>
              <div className="title-content-modal">
                顧客データのCSVファイルをアップロードしてください。
              </div>
              <ContractUploader
                key={file?.name}
                file={file}
                onSuccess={onSuccess}
                onDelete={onDelete}
              />
            </>
          )}
          {importStatus === "validate" && (
            <>
              <div className="title-content-modal">
                顧客データのCSVファイルのアップロード結果は以下です。
              </div>
              <div className="validate-result">
                <div className="success-contract">
                  <div className="title-success">成功 ：</div>
                  <div className="data-success">
                    <div>{dataValidate.totalRows}件</div>
                    <div>重複：{dataValidate.totalDuplicate}件</div>
                    <div>上書き：{dataValidate.totalUpdate}件</div>
                    <div className="list-update">
                      {dataValidate.availability.map((item) => (
                        <div key={item}>{item}</div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="fail-contract">
                  <div className="title-error">失敗 ：</div>
                  <div className="data-error">
                    <div>{dataValidate.totalRowIncorrect}件</div>
                    <div className="list-error">
                      {dataValidate.error.map((item, index) => {
                        return (
                          <div key={index} className="mb-2">
                            <b className="mb-1">{item.message}</b>
                            <br />
                            {item.list.map((e) => (
                              <span key={e}>
                                {e}
                                <br />
                              </span>
                            ))}
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </div>
              </div>

              {dataValidate.totalRows > 0 || dataValidate.totalUpdate > 0 ? (
                <div className="validate-success-note">
                  上記内容でインポートしてよろしいですか？
                </div>
              ) : (
                <div className="validate-fail-note">
                  <div>インポートできるデータがありません。</div>
                  <div>CSVファイルをご確認いただき、再度アップロードしてください。</div>
                </div>
              )}
            </>
          )}
          {importStatus === "done" && (
            <div className="note-done">
              <p>CSVファイルのインポートが完了しました。</p>
              <p>顧客一覧画面の「下書き」より確認できます。</p>
            </div>
          )}
        </ModalContent>

        <React.Fragment key={"footer"}>
          {importStatus === "upload" && (
            <AcButton
              className="btn-conversion upload-btn"
              disabled={!file?.name}
              onClick={onValidateFile}
            >
              アップロードする
            </AcButton>
          )}
          {importStatus === "validate" && (
            <>
              <AcButton className="btn-back" onClick={() => setImportStatus("upload")}>
                戻る
              </AcButton>
              {(dataValidate.totalRows > 0 || dataValidate.totalUpdate > 0) && (
                <AcButton className="btn-conversion" onClick={onImportCSV}>
                  インポートする
                </AcButton>
              )}
            </>
          )}
          {importStatus === "done" && (
            <AcButton className="btn-conversion" onClick={toDraftList}>
              顧客一覧の下書きへ
            </AcButton>
          )}
        </React.Fragment>
      </AcModal>
    </>
  )
}

export default ModalImportCSV

const ModalContent = styled.div`
  .title-content-modal {
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .validate-result {
    font-size: 14px;
    max-width: 90%;
    width: 550px;
    margin: 10px auto;
    height: 300px;
    overflow-y: auto;
    background-color: #f8f8f8;
    padding: 15px 20px;

    .success-contract {
      display: flex;
      color: #11bc4c;
      margin-bottom: 20px;
    }

    .fail-contract {
      display: flex;
      color: #ff0000;
    }

    .list-error,
    .list-update {
      font-size: 12px;
      margin-top: 5px;
    }
    .list-update {
      color: #222222;
    }
  }

  .title-success,
  .title-error {
    flex-shrink: 0;
  }
  .data-success,
  .data-error {
    flex-shrink: 1;
  }

  .validate-success-note {
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
    font-weight: 600;
  }
  .validate-fail-note {
    text-align: center;
    margin-top: 10px;
    margin-bottom: 10px;
    color: #ff0000;
    font-weight: 600;
  }

  .note-done {
    text-align: center;
    margin-top: 40px;
    margin-bottom: 40px;

    p {
      margin-bottom: 15px !important;
      font-weight: 700;
    }
  }
`
const OnverloadText = styled.div`
  text-align: center;
  color: #ff0000;
  font-size: 16px;
  margin-top: 150px;
  margin-bottom: 150px;
  .over-note {
    font-size: 20px;
    margin-bottom: 20px !important;
    font-weight: 600;
  }
`
const ImportFileError = styled.div`
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  margin-top: 40px;
  margin-bottom: 40px;
`
